import TICKETS from './ActionPatternTicket';
import ASSIGNMENTS from './ActionPatternAssignment';
import DRIVER_CREWS from './ActionPatternDriverCrew';
import BOOKING_SESSIONS from './ActionPatternBookingSession';
import APP_CONFIG from './ActionPatternAppConfig';
import TAGS from './ActionPatternTag';

export const ACTIONS = {
  TICKETS,
  ASSIGNMENTS,
  DRIVER_CREWS,
  BOOKING_SESSIONS,
  VIEW_DASHBOARD: [
    {
      method: 'GET',
      path: 'statistics/regions/{region}/date/{date}/projection',
    },
    {
      method: 'GET',
      path: 'statistics/regions/{region}/date/{date}',
    },
  ],
  APP_CONFIG,
  TAGS,
  REGION_SETTINGS: [
    {
      method: 'GET',
      path: 'bonus-ineligible/settings',
    },
    {
      method: 'PUT',
      path: 'bonus-ineligible/settings/{region_code}/off',
    },
  ],
};
